export const MENU_ITEMS = [
  { title: 'Dashboard', icon: 'dashboard', route: { name: 'dashboard' } },
  { title: 'Users', icon: 'user', route: { name: 'user' } },
  { title: 'Marketing', icon: 'mail', route: { name: 'marketing' } }
] as const

const isProd = process.env.NODE_ENV === 'production'

export const APP_CONFIGS = {
  griddiary: {
    name: 'Grid Diary',
    logo: 'logo-griddiary.svg',
    routeParams: { app: 'griddiary' },
    apiUri: 'https://diary-id-hasura.sumi.io/v1alpha1/graphql',
    voidApiUri: isProd
      ? 'https://diary-id.sumi.io/api'
      : 'http://localhost:4000/api',
    marketingApiUri: 'https://marketing.sumi.io/api'
  },
  gridnote: {
    name: 'Grid Note',
    logo: 'gridnote_logo.svg',
    routeParams: { app: 'gridnote' },
    apiUri: 'https://note-id-hasura.sumi.io/v1alpha1/graphql',
    voidApiUri: isProd
      ? 'https://note-id.sumi.io/api'
      : 'http://localhost:4000/api',
    marketingApiUri: 'https://marketing.sumi.io/api'
  }
}

export type AppKey = keyof typeof APP_CONFIGS
export type AppConfig = typeof APP_CONFIGS['griddiary']
